export default __webpack_public_path__ + "static/media/benefits_1.ae54b2dc.png";